import store from "@/store";

const isAuthenticatedGuard = async(to: any, _: any, next: any) => {
    document.title = to.meta.title;
    const status = store.getters['auth/currentState'];
    if (status == 'authenticated') {
        next();
    } else {
        next({ name: 'login' });
    }
}

const isNotAuthenticatedGuard = async(to: any, _: any, next: any) => {
    document.title = to.meta.title;
    next();
}

const hasPermissionGuard = (modulo: string, accion = 'ver') => async (to: any, _: any, next: any) => {
    document.title = to.meta.title;
    const tienePermiso = store.getters['auth/tienePermiso'];
    if (tienePermiso(modulo, accion)) {
        next();
    } else {
        next({ name: 'system' });
    }
}

export {
    isNotAuthenticatedGuard,
    isAuthenticatedGuard,
    hasPermissionGuard
};
